import { useContext } from 'react';

import { SyncContext, type SyncContextValue } from './sync-context';
import { INITIAL_SYNC_STATE } from './sync-engine';

/**
 * Status van de synchronisatie. Buiten een `SyncProvider` levert de hook een
 * neutrale, stille status op - handig in tests en in losse verhalen.
 */
export function useSyncState(): SyncContextValue {
    return (
        useContext(SyncContext) ?? {
            state: INITIAL_SYNC_STATE,
            engine: null,
            flushNow: async () => {},
            retryFailed: async () => {},
        }
    );
}
